import { Box, InputBase, Typography } from "@mui/material"
import { useTranslation } from "react-i18next";


export const FieldValoration = ({name, title, handleInputChange, required = false, disabled = false}) => {

    const { t } = useTranslation('global');

    return (
        <Box minWidth='calc(50% - 8px)'>
            <Typography variant='overline' color='secondary'>{t(`valorationStartup.${title}`)}</Typography>
            <InputBase 
                fullWidth
                name={title}
                size="small"
                variant="standard"
                value={name || ''}
                onChange={handleInputChange}
                required={required}
                disabled={disabled}
            />
        </Box>
    )
}